import React from "react"

const ProfileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path d="M16 4.167a1.333 1.333 0 00-1.333-1.334h-4a.333.333 0 00-.334.334v1a.333.333 0 01-.666 0V2.5a2 2 0 00-4 0v1.667a.333.333 0 01-.667 0v-1a.333.333 0 00-.333-.334H1.333A1.333 1.333 0 000 4.167v10A1.333 1.333 0 001.333 15.5h13.334A1.333 1.333 0 0016 14.167zM7 2.333A.667.667 0 117.667 3 .667.667 0 017 2.333zM1.667 14.167a.333.333 0 01-.334-.334v-7a.333.333 0 01.334-.333h12.666a.333.333 0 01.334.333v7a.333.333 0 01-.334.334z" />
      <path d="M12.833 9H9.667a.5.5 0 000 1h3.166a.5.5 0 000-1zM12 11H9.667a.5.5 0 000 1H12a.5.5 0 000-1zM3.997 9.167a1.333 1.333 0 102.667 0 1.333 1.333 0 10-2.667 0zM5.333 11.167a2.4 2.4 0 00-2.2 1.544.333.333 0 00.314.456h3.766a.333.333 0 00.314-.456 2.4 2.4 0 00-2.194-1.544z" />
    </svg>
  )
}

const CameraIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15">
      <path
        d="M9.219 5.86a2.344 2.344 0 110 4.687 2.344 2.344 0 010-4.688zm4.184-2.032h-.823a.334.334 0 01-.3-.216c-.387-.815-.786-1.659-1.655-1.659H7.5c-.67 0-1.022.486-1.662 1.37-.24.329-.319.505-.527.505H1.56C.27 3.828 0 4.584 0 5.218v6.492a1.41 1.41 0 001.597 1.493h11.806A1.408 1.408 0 0015 11.71V5.217c0-.633-.277-1.389-1.598-1.389zm-.59 4.375a3.593 3.593 0 11-7.187 0 3.593 3.593 0 017.186 0zM3.124 6.172a.782.782 0 11-1.563 0 .782.782 0 011.563 0zM1.562 3.193l1.875.01c.173 0 .313-.14.313-.312v-.157a.938.938 0 00-.938-.937h-.624a.938.938 0 00-.938.937v.147c0 .172.14.312.313.312z"
        fill="#fafafa"
      />
    </svg>
  )
}

const PasswordIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <path d="M13 6.333h-.5V4.5a4.5 4.5 0 00-9 0v1.833H3a1.333 1.333 0 00-1.333 1.334v7A1.333 1.333 0 003 16h10a1.333 1.333 0 001.333-1.333v-7A1.333 1.333 0 0013 6.333zM10.333 12a.667.667 0 11.667-.667.667.667 0 01-.667.667zM11 13.667a.667.667 0 11-.667-.667.667.667 0 01.667.667zm-.667-4A.667.667 0 1111 9a.667.667 0 01-.667.667zM8 12a.667.667 0 11.667-.667A.667.667 0 018 12zm.667 1.667A.667.667 0 118 13a.667.667 0 01.667.667zm-.667-4A.667.667 0 118.667 9 .667.667 0 018 9.667zM5.667 12a.667.667 0 11.666-.667.667.667 0 01-.666.667zm.666 1.667A.667.667 0 115.667 13a.667.667 0 01.666.667zm-.666-4A.667.667 0 116.333 9a.667.667 0 01-.666.667zm-.5-5.167a2.833 2.833 0 015.666 0V6a.333.333 0 01-.333.333h-5A.333.333 0 015.167 6z" />
    </svg>
  )
}

const VaccineIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <path d="M12.261 4.681a.333.333 0 01.369-.07 2.257 2.257 0 00.903.189A2.333 2.333 0 1011.2 2.467a2.257 2.257 0 00.191.9.333.333 0 01-.066.369l-.901.897a.333.333 0 01-.471 0l-.145-.144a.333.333 0 01-.07-.368 2.259 2.259 0 00.19-.901 2.318 2.318 0 00-.683-1.65 2.39 2.39 0 00-3.3 0 2.317 2.317 0 00-.684 1.65.667.667 0 101.334 0 .99.99 0 01.293-.707 1.023 1.023 0 011.414 0 1 1 0 010 1.412l-2.22 2.222-3.3 3.299a2.661 2.661 0 00-.513 3.028.333.333 0 01-.066.38l-1.87 1.872a.667.667 0 00.941.94L3.146 13.8a.333.333 0 01.38-.067 2.657 2.657 0 003.028-.514l3.3-3.3 2.22-2.22a1 1 0 11.706 1.708.667.667 0 000 1.334 2.33 2.33 0 10-.901-4.474.333.333 0 01-.366-.072l-.146-.146a.333.333 0 010-.472zm1.272-3.214a1 1 0 11-1 1 1 1 0 011-1zm-3.106 5.52a.333.333 0 010 .472l-.809.808a.333.333 0 01-.471 0l-.708-.707-.706-.707a.333.333 0 010-.471l.807-.807a.333.333 0 01.471 0z" />
    </svg>
  )
}

const InsuranceIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <g transform="matrix(0.6666666666666666,0,0,0.6666666666666666,0,0)">
        <path
          d="M24,6.125A1.127,1.127,0,0,0,22.875,5H19.5a.5.5,0,0,1-.5-.5V1.125A1.127,1.127,0,0,0,17.875,0h-3.75A1.127,1.127,0,0,0,13,1.125V4.5a.5.5,0,0,1-.5.5H9.125A1.127,1.127,0,0,0,8,6.125v3.75A1.127,1.127,0,0,0,9.125,11H12.5a.5.5,0,0,1,.5.5v3.375A1.127,1.127,0,0,0,14.125,16h3.75A1.127,1.127,0,0,0,19,14.875V11.5a.5.5,0,0,1,.5-.5h3.375A1.127,1.127,0,0,0,24,9.875Z"
          stroke="none"
        />
        <path
          d="M1,14.75a1,1,0,0,0-1,1V23a1,1,0,0,0,2,0V15.75A1,1,0,0,0,1,14.75Z"
          stroke="none"
        />
        <path
          d="M15.5,19.5H6.375a.625.625,0,0,1,0-1.25H8.9a1,1,0,0,0,.92-1.394A2.234,2.234,0,0,0,7.764,15.5H3.5A.5.5,0,0,0,3,16v6.5a.5.5,0,0,0,.5.5H14.264A2.238,2.238,0,0,0,16.5,20.764V20.5A1,1,0,0,0,15.5,19.5Z"
          stroke="none"
        />
      </g>
    </svg>
  )
}

const BenefitsIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill={fill}
    >
      <path d="M7.667 2.333a2 2 0 104 0 2 2 0 10-4 0zM7.636 6.89a.167.167 0 00.2.067 11.916 11.916 0 013.817-.667h.153a.167.167 0 00.129-.277 3.036 3.036 0 00-4.667.157.167.167 0 00.003.207 4.733 4.733 0 01.365.513zM6.333 11.19V8.93A2.023 2.023 0 016.8 7.642a.167.167 0 00.014-.192A3.667 3.667 0 000 9.333v2.334A.333.333 0 00.333 12H1.54a.167.167 0 01.166.153L2 15.695a.333.333 0 00.333.305H5a.333.333 0 00.333-.305l.296-3.542A.167.167 0 015.793 12h.418a.166.166 0 00.164-.189 4.837 4.837 0 01-.042-.62zM1.333 2.333a2.333 2.333 0 104.667 0 2.333 2.333 0 10-4.667 0zM15.382 8.027a10.933 10.933 0 00-3.73-.694 10.662 10.662 0 00-3.7.694 1.031 1.031 0 00-.619.944v2.262a5.145 5.145 0 003.461 4.536l.368.141a1.38 1.38 0 00.98 0l.37-.14C14.564 14.986 16 13.12 16 11.232V8.97a1.03 1.03 0 00-.618-.944zm-3.215 2.306a.167.167 0 00.166.167h1.334a.5.5 0 010 1h-1.334a.167.167 0 00-.166.167V13a.5.5 0 01-1 0v-1.333A.167.167 0 0011 11.5H9.667a.5.5 0 010-1H11a.167.167 0 00.167-.167V9a.5.5 0 011 0z" />
    </svg>
  )
}

const ResumeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16">
      <path d="M8.5 3.333h-4a.5.5 0 000 1h4a.5.5 0 000-1zM9 6.167a.5.5 0 00-.5-.5H3.167a.5.5 0 000 1H8.5a.5.5 0 00.5-.5zM3.167 8a.5.5 0 000 1h3.666a.5.5 0 000-1z" />
      <path d="M7.533 11.77a.168.168 0 00-.154-.103H1.667a.333.333 0 01-.334-.334V1.667a.333.333 0 01.334-.334h8.666a.333.333 0 01.334.334V8.38a.167.167 0 00.284.117l.854-.853A.667.667 0 0012 7.173v-5.84A1.333 1.333 0 0010.667 0H1.333A1.333 1.333 0 000 1.333v10.334A1.333 1.333 0 001.333 13H6.58a.333.333 0 00.318-.235 1.29 1.29 0 01.334-.546l.266-.267a.167.167 0 00.036-.182zM8.041 13.42a.167.167 0 00-.281.086L7.341 15.6a.333.333 0 00.327.4.31.31 0 00.067-.007l2.095-.419a.167.167 0 00.085-.281zM15.485 7.843a1.747 1.747 0 00-2.466 0l-4.334 4.334a.333.333 0 000 .471l2 2a.333.333 0 00.472 0l4.333-4.333a1.747 1.747 0 00-.005-2.472z" />
    </svg>
  )
}

const SettingsIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <path d="M14.947 6.509l-.844-.3a.916.916 0 01-.52-1.257l.384-.809a1.584 1.584 0 00-2.11-2.11l-.808.385a.917.917 0 01-1.257-.521l-.3-.844a1.584 1.584 0 00-2.984 0l-.3.844a.917.917 0 01-1.257.521l-.808-.385a1.584 1.584 0 00-2.11 2.11l.384.809a.917.917 0 01-.52 1.257l-.844.3a1.583 1.583 0 000 2.984l.844.3a.916.916 0 01.52 1.256l-.384.809a1.584 1.584 0 002.11 2.11l.808-.384a.915.915 0 011.257.52l.3.844a1.584 1.584 0 002.984 0l.3-.844a.916.916 0 011.257-.52l.808.384a1.584 1.584 0 002.11-2.11l-.384-.809a.916.916 0 01.52-1.256l.844-.301a1.583 1.583 0 000-2.983zM8 11.19a3.287 3.287 0 01-2.96-1.963A3.209 3.209 0 016.772 5.04a3.245 3.245 0 014.187 1.733 3.209 3.209 0 01-1.733 4.188A3.06 3.06 0 018 11.19z" />
    </svg>
  )
}

const CompanyIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill={fill}
    >
      <path d="M15.833 15.29a.653.653 0 00-.652-.654h-1.793a.167.167 0 01-.167-.167v-3.303a.167.167 0 01.167-.167h.769a1.751 1.751 0 001.676-1.775 1.673 1.673 0 00-.809-1.43.168.168 0 01-.08-.144v-.503a3.092 3.092 0 00-3.01-3.16 3.091 3.091 0 00-3.012 3.16 3.205 3.205 0 00.1.8.167.167 0 01-.05.165 1.903 1.903 0 00-.643 1.409 1.639 1.639 0 00.788 1.38.49.49 0 00.294.098h.17a.167.167 0 01.16.121 3.143 3.143 0 002.059 2.086.167.167 0 01.118.16v1.1a.167.167 0 01-.167.167H7.514a.167.167 0 01-.167-.166V4.518a.98.98 0 00-.979-.979h-.813a.167.167 0 01-.166-.166v-1.14a.653.653 0 00-.656-.652H4.58a.166.166 0 01-.167-.169l.01-.693A.653.653 0 003.78.057h-.009a.653.653 0 00-.653.645l-.008.714a.167.167 0 01-.167.165h-.166a.653.653 0 00-.653.652v1.14a.167.167 0 01-.166.166h-.813a.98.98 0 00-.98.979v11.097a.327.327 0 00.327.327h14.688a.653.653 0 00.652-.653zm-4.6-4.029a.167.167 0 01.134-.262h.382a.167.167 0 01.166.167v.392a.167.167 0 01-.266.133 1.887 1.887 0 01-.418-.43zM5.552 9.85a.49.49 0 01-.49.49h-2.61a.49.49 0 010-.98h2.61a.49.49 0 01.49.49zm0 3.155a.49.49 0 01-.49.49h-2.61a.49.49 0 010-.98h2.61a.49.49 0 01.49.49zm-.49-5.93h-2.61a.49.49 0 010-.979h2.61a.49.49 0 010 .98z" />
    </svg>
  )
}

const EditIcon = ({ fill = "orange", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill={fill}
    >
      <path d="M1.656 10.25a.312.312 0 00-.526.153l-.884 3.978a.312.312 0 00.373.373l3.977-.883a.312.312 0 00.153-.527L1.656 10.25zm9.502-5.745l-6.85 6.85a.157.157 0 000 .221l1.105 1.105c.123.12.318.12.441 0l6.63-6.63a.313.313 0 000-.441l-1.105-1.105a.157.157 0 00-.221 0zm-.663-.884L9.39 2.517a.313.313 0 00-.442 0l-6.63 6.629a.313.313 0 000 .441l1.106 1.106c.061.06.16.06.221 0l6.85-6.85a.157.157 0 000-.222zM14.031.97a2.503 2.503 0 00-3.537 0l-.441.442a.313.313 0 000 .442l3.093 3.093a.321.321 0 00.442 0l.443-.442a2.5 2.5 0 000-3.535z" />
    </svg>
  )
}

const BankIcon = () => {
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M14.483 11.94A6.534 6.534 0 018 6.222a.208.208 0 00-.22-.182c-.294.02-.587.055-.876.108a2.767 2.767 0 00-2.942-1.065.75.75 0 00-.323 1.263c.217.204.384.455.488.733.033.09.002.19-.076.243a5.696 5.696 0 00-2.341 3.244.207.207 0 01-.202.156h-.22c-.598 0-1.083.485-1.083 1.084v1.347c0 .599.485 1.084 1.083 1.084h.772a.21.21 0 01.182.105 6.11 6.11 0 002.06 2.105l-.624 2.152c-.157.541.154 1.106.694 1.263l.002.001a1.02 1.02 0 001.265-.697l.486-1.678a.209.209 0 01.25-.143 7.739 7.739 0 003.976.004.209.209 0 01.25.143l.492 1.675a1.02 1.02 0 001.961-.565v-.003l-.584-2a.208.208 0 01.083-.232 5.59 5.59 0 002.603-4.221.208.208 0 00-.223-.222c-.145.01-.297.016-.45.016z"
          fill="#000"
        />
        <path
          d="M3.577 10.797a.745.745 0 111.49.01.745.745 0 01-1.49-.01z"
          fill="#FFF"
        />
        <path
          d="M14.483 10.715A5.31 5.31 0 1014.484.094a5.31 5.31 0 000 10.621z"
          fill="#1A79EC"
        />
        <path
          d="M15.096 2.132c0 .115.093.208.208.208h.404a.613.613 0 010 1.226h-1.66a.484.484 0 00-.181.934l1.686.675a1.703 1.703 0 01-.29 3.25.209.209 0 00-.167.204v.25a.613.613 0 01-1.226 0v-.2a.208.208 0 00-.208-.208h-.404a.613.613 0 010-1.226h1.659a.483.483 0 00.18-.932l-1.68-.677a1.702 1.702 0 01.291-3.25.207.207 0 00.167-.204v-.25a.614.614 0 111.226 0l-.005.2z"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

const UndoIcon = ({ fill = "#1a79ec" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={fill}>
      <path d="M7.946 2.667a.162.162 0 01-.115-.276l1.253-1.253a.667.667 0 10-.943-.943L5.475 2.862a.667.667 0 000 .944L8.14 6.473a.667.667 0 10.943-.943L7.831 4.276A.162.162 0 017.946 4a5.333 5.333 0 010 10.667.667.667 0 100 1.333 6.667 6.667 0 000-13.333zM5.885 14.254a5.339 5.339 0 01-1.152-.66.668.668 0 00-.804 1.066 6.69 6.69 0 001.438.827.667.667 0 00.515-1.23zM2.709 10.349a.667.667 0 10-1.309.254 6.72 6.72 0 00.563 1.672.668.668 0 001.2-.589 5.307 5.307 0 01-.454-1.337zM2.959 5.927a.667.667 0 00-.902.277 6.68 6.68 0 00-.626 1.715.667.667 0 001.302.281 5.341 5.341 0 01.502-1.375.667.667 0 00-.276-.898z" />
    </svg>
  )
}

const ArrowBack = () => {
  return (
    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12c6.624-.007 11.993-5.376 12-12zm-13.707 5.2l-4.5-4.5a1 1 0 0 1 0-1.414l4.5-4.5A1 1 0 1 1 11.707 8.2l-2.366 2.371a.25.25 0 0 0 .177.429H18a1 1 0 0 1 0 2H9.518a.25.25 0 0 0-.177.426l2.366 2.367a1 1 0 0 1-1.414 1.407z"
        fill="#F47A19"
      />
    </svg>
  )
}

const ArrowRight = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      style={style}
    >
      <g
        stroke="#000"
        fill="none"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M.438 7h13.124M7.438 13.125L13.563 7 7.436.875"
          strokeWidth=".874995"
        />
      </g>
    </svg>
  )
}

const UserInfoIcon = () => {
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M9.446 10.35a.416.416 0 00-.098-.618 6.23 6.23 0 00-9.333 3.482.416.416 0 00.402.536h7.2a.416.416 0 00.41-.342 6.632 6.632 0 011.419-3.059zM5.833 0a3.959 3.959 0 110 7.917 3.959 3.959 0 010-7.917z"
          fill="#000"
        />
        <path
          d="M14.583 9.167a5.417 5.417 0 100 10.833 5.417 5.417 0 000-10.833z"
          fill="#1A79EC"
        />
        <path
          d="M15 11.874a.834.834 0 11-1.667 0 .834.834 0 011.667 0zM12.708 17.5c0-.345.28-.625.625-.625h.209c.23 0 .416-.187.416-.417V15a.208.208 0 00-.208-.208h-.417a.625.625 0 010-1.25h.834c.575 0 1.04.466 1.041 1.041v1.875c0 .23.187.417.417.417h.208a.625.625 0 010 1.25h-2.5a.625.625 0 01-.625-.625z"
          fill="#FFF"
        />
      </g>
    </svg>
  )
}

const PhoneIcon = ({ width = "20", height = "20" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.474 13.742l-2.043-2.044a2.343 2.343 0 00-3.313-.003l-.003.003-.417.417A45.305 45.305 0 017.03 6.439l.417-.417c.913-.916.913-2.399 0-3.315L5.399.666a2.402 2.402 0 00-3.319 0L.963 1.787A3.318 3.318 0 00.547 5.95 45.14 45.14 0 0013.19 18.596a3.345 3.345 0 004.167-.417l1.12-1.122a2.341 2.341 0 00.004-3.31l-.004-.004h-.004z"
        fill="#1A79EC"
        fillRule="nonzero"
      />
    </svg>
  )
}

const HomeLocationIcon = () => {
  return (
    <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
      <g fillRule="nonzero" fill="none">
        <path
          d="M8.417 16.633a1.666 1.666 0 01-.743-2.905l4.876-4.127a.42.42 0 00.12-.167 8.55 8.55 0 00.663-2.767A6.667 6.667 0 000 6.667c0 3.536 6.06 12.755 6.32 13.146a.417.417 0 00.694 0c.083-.13.808-1.228 1.734-2.765v-.008a.417.417 0 00-.331-.407z"
          fill="#1A79EC"
        />
        <path
          d="M6.667 8.75a2.083 2.083 0 110-4.166 2.083 2.083 0 010 4.166z"
          fill="#FFF"
        />
        <path
          d="M19.852 14.682l-5.417-4.584a.417.417 0 00-.54 0L8.48 14.682a.416.416 0 00.27.735h.833c.23 0 .416.186.416.416v3.75c0 .23.187.417.417.417H12.5c.23 0 .417-.187.417-.417v-1.875a1.25 1.25 0 012.5 0v1.875c0 .23.186.417.416.417h2.084c.23 0 .416-.187.416-.417v-3.75c0-.23.187-.416.417-.416h.833a.416.416 0 00.269-.735z"
          fill="#000"
        />
      </g>
    </svg>
  )
}

const CheckIcon = ({
  fill = "#00b432",
  width = "16",
  height = "16",
  style = {},
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill={fill}
      style={style}
    >
      <path d="M8 0a8 8 0 1 0 8 8 8 8 0 0 0-8-8Zm4.62 5.467L8.053 11.66a.667.667 0 0 1-.953.127L3.84 9.18a.667.667 0 0 1-.1-.94.667.667 0 0 1 .927-.1l2.72 2.173 4.16-5.646a.667.667 0 0 1 .926-.14.667.667 0 0 1 .147.94Z" />
    </svg>
  )
}

const Check2Icon = ({ fill = "orange" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill={fill}
    >
      <path d="M15.43 3.6l-1.86-1.867a.333.333 0 00-.473 0L5.236 9.6a.333.333 0 01-.472 0L2.903 7.733a.333.333 0 00-.472 0L.569 9.6a.333.333 0 000 .471l4.195 4.196a.333.333 0 00.472 0l10.195-10.2a.333.333 0 000-.467z" />
    </svg>
  )
}

const RemoveIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10">
      <path
        d="M9.443 2.324a.625.625 0 000-.884L8.56.557a.625.625 0 00-.884 0L5.073 3.159a.105.105 0 01-.148 0L2.325.557a.625.625 0 00-.884 0l-.884.883a.625.625 0 000 .884l2.602 2.602c.04.041.04.107 0 .148L.557 7.676a.625.625 0 000 .884l.883.883c.245.244.64.244.884 0l2.602-2.602c.041-.04.107-.04.148 0l2.601 2.602c.245.244.64.244.884 0l.884-.883a.625.625 0 000-.884L6.841 5.074a.105.105 0 010-.148l2.602-2.602z"
        fill="#fff"
      />
    </svg>
  )
}

const QuestionMarkIcon = ({ fill = "#1a79ec" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill={fill}>
      <path d="M8 0a8 8 0 108 8 8.009 8.009 0 00-8-8zm0 12.667a1 1 0 111-1 1 1 0 01-1 1zm1.067-4.054a.667.667 0 00-.4.612.667.667 0 11-1.334 0 2 2 0 011.2-1.834A1.333 1.333 0 106.667 6.17a.667.667 0 11-1.334 0 2.667 2.667 0 113.734 2.444z" />
    </svg>
  )
}

const UploadIcon = ({ fill = "#ff9600" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
      fill={fill}
    >
      <path d="M13.143 6.904A4.857 4.857 0 003.639 5.73 4 4 0 004 13.714h8.571a3.429 3.429 0 00.572-6.81zm-2.965 1.798a.86.86 0 01-.75.44h-.57v2a.857.857 0 01-1.715 0v-2H6.57a.857.857 0 01-.726-1.31l1.428-2.286a.89.89 0 011.454 0l1.428 2.286a.858.858 0 01.023.87z" />
    </svg>
  )
}

const ExclamationIcon = ({ fill = "#ff9600" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="16"
      height="16"
    >
      <path
        fill={fill}
        d="M7.989 0a8.137 8.137 0 00-5.674 2.435A7.867 7.867 0 000 8.138 7.853 7.853 0 007.867 16h.142A8.074 8.074 0 0016 7.86 7.844 7.844 0 007.989 0zM7 11.028a.984.984 0 01.966-1.02h.018a1.018 1.018 0 011.015.98.983.983 0 01-.966 1.02h-.018A1.02 1.02 0 017 11.028zm.333-2.695v-4a.667.667 0 011.334 0v4a.667.667 0 11-1.334 0z"
      />
    </svg>
  )
}

const AssetIcon = ({ fill = "#222", width = "16", height = "16" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill={fill}
    >
      <g transform="matrix(1.6,0,0,1.6,0,0)">
        <path
          d="M10,1.1A1.1,1.1,0,0,0,8.9,0H1.1A1.1,1.1,0,0,0,0,1.1V6.4A1.1,1.1,0,0,0,1.1,7.5H3.681a.25.25,0,0,1,.232.343l-.337.843A.5.5,0,0,1,3.112,9H2a.5.5,0,0,0,0,1H8A.5.5,0,0,0,8,9H6.888a.5.5,0,0,1-.464-.314l-.337-.843A.25.25,0,0,1,6.319,7.5H8.9A1.1,1.1,0,0,0,10,6.4ZM8.5,5.75A.25.25,0,0,1,8.25,6H1.75a.25.25,0,0,1-.25-.25v-4a.25.25,0,0,1,.25-.25h6.5a.25.25,0,0,1,.25.25Z"
          stroke="none"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="0"
        />
      </g>
    </svg>
  )
}

const PdfIcon = ({ fill = "red", width = "16", height = "16", style = {} }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      fill={fill}
      style={style}
    >
      <g>
        <path d="M5.633 8.213c-.066 0-.22-.033-.22.114v2.666a.16.16 0 0 0 .22.14 1.573 1.573 0 0 0 .954-1.466 1.593 1.593 0 0 0-.954-1.454ZM2.667 8.08h-.414a.173.173 0 0 0-.173.173v.827a.173.173 0 0 0 .173.167h.414a.587.587 0 1 0 0-1.167Z" />
        <path d="M12 12.667v-6A.667.667 0 0 0 11.333 6H.667A.667.667 0 0 0 0 6.667v6a.667.667 0 0 0 .667.666h10.666a.667.667 0 0 0 .667-.666ZM2.667 10.08h-.414a.173.173 0 0 0-.173.173v1.414a.413.413 0 1 1-.827 0v-4a.42.42 0 0 1 .414-.42h1a1.42 1.42 0 0 1 0 2.833Zm2.333 2a.413.413 0 0 1-.413-.413v-4A.42.42 0 0 1 5 7.247a2.42 2.42 0 0 1 0 4.833Zm5.333-4H9a.253.253 0 0 0-.253.253v.747a.173.173 0 0 0 .173.167h.747a.42.42 0 0 1 0 .833H8.92a.173.173 0 0 0-.173.173v1.414a.413.413 0 1 1-.827 0V8.333A1.08 1.08 0 0 1 9 7.247h1.333a.42.42 0 0 1 0 .833Z" />
        <path d="M15.807 3.807 12.193.193A.667.667 0 0 0 11.727 0H4a1.333 1.333 0 0 0-1.333 1.333v3.834a.167.167 0 0 0 .166.166h1A.167.167 0 0 0 4 5.167v-3.5a.333.333 0 0 1 .333-.334h6.834a.167.167 0 0 1 .166.167v1.833a1.333 1.333 0 0 0 1.334 1.334H14.5a.167.167 0 0 1 .167.166v9.5a.333.333 0 0 1-.334.334H4.167A.167.167 0 0 1 4 14.5v-.333A.167.167 0 0 0 3.833 14h-1a.167.167 0 0 0-.166.167v.5A1.333 1.333 0 0 0 4 16h10.667A1.333 1.333 0 0 0 16 14.667V4.273a.667.667 0 0 0-.193-.466Z" />
      </g>
    </svg>
  )
}

const LinkIcon = ({ width = 17, height = 17 }) => {
  return (
    <svg viewBox="0 0 17 17" width={width} height={height}>
      <g
        id="Page-1"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g id="Group" fillRule="nonzero" transform="translate(.138 .085)">
          <path
            id="Path"
            fill="#000"
            d="m8.129 1.367-1.42 1.472a1.198 1.198 0 0 0 0 1.699 1.19 1.19 0 0 0 1.682 0l1.42-1.412a2.18 2.18 0 0 1 3.736.932 2.194 2.194 0 0 1-.646 2.155l-1.42 1.412a1.199 1.199 0 0 0 0 1.687 1.19 1.19 0 0 0 1.683 0l1.42-1.412a4.591 4.591 0 0 0 1.27-4.465 4.576 4.576 0 0 0-3.27-3.287 4.56 4.56 0 0 0-4.455 1.267v-.048ZM7.604 11.465l-1.503 1.508a2.179 2.179 0 0 1-3.011-.079 2.194 2.194 0 0 1-.067-3.02l1.491-1.508a1.199 1.199 0 0 0-.497-2.072 1.191 1.191 0 0 0-1.185.385L1.329 8.187a4.592 4.592 0 0 0-.98 4.987A4.57 4.57 0 0 0 4.562 16a4.503 4.503 0 0 0 3.221-1.34l1.503-1.508a1.199 1.199 0 0 0-.062-1.624 1.19 1.19 0 0 0-1.62-.063Z"
          />
          <path
            id="Path"
            fill="#1A79EC"
            d="M10.777 5.232a1.19 1.19 0 0 0-1.682 0L4.872 9.419a1.199 1.199 0 0 0 .847 2.041c.318 0 .623-.127.847-.354l4.211-4.235a1.199 1.199 0 0 0 0-1.64Z"
          />
        </g>
      </g>
    </svg>
  )
}

const CopyIcon = ({ fill = "#1A79EC", width = 16, height = 16 }) => {
  return (
    <svg viewBox="0 0 16 16" width={width} height={height} fill={fill}>
      <path d="M8.933 3.153a.16.16 0 0 0 .134.174.727.727 0 0 1 .546.74V5a.827.827 0 0 0 .834.827.82.82 0 0 0 .826-.827V2.667a1 1 0 0 0-.993-1H9.127a.193.193 0 0 0-.12.046.173.173 0 0 0-.047.12c0 .3 0 .98-.027 1.32ZM6 14.173a.82.82 0 0 0-.86-.84H2.32a.713.713 0 0 1-.667-.76V4.067a.72.72 0 0 1 .567-.734.167.167 0 0 0 .133-.173V1.827a.167.167 0 0 0-.166-.167H1a1 1 0 0 0-1 1.007V14a1 1 0 0 0 .993 1H5.14a.827.827 0 0 0 .86-.827ZM7.96 2.98V1.647a.333.333 0 0 0-.333-.327H7.12a.173.173 0 0 1-.167-.147 1.333 1.333 0 0 0-2.633 0 .167.167 0 0 1-.167.16h-.506a.327.327 0 0 0-.314.32v1.334a.327.327 0 0 0 .327.333h4a.333.333 0 0 0 .3-.34ZM12.667 11.513H10a.5.5 0 0 0 0 1h2.667a.5.5 0 0 0 0-1ZM9.527 9.693a.507.507 0 0 0 .5.5h1.66a.5.5 0 0 0 0-1H10a.507.507 0 0 0-.473.5Z" />
      <path d="M15.667 8.973a1.333 1.333 0 0 0-.387-.94l-.94-.933a1.333 1.333 0 0 0-.94-.393H8.327A1.333 1.333 0 0 0 6.993 8.04v6.627A1.333 1.333 0 0 0 8.327 16h6a1.333 1.333 0 0 0 1.333-1.333Zm-7.334-.266A.667.667 0 0 1 9 8.04h4.127a.667.667 0 0 1 .473.193l.547.547a.667.667 0 0 1 .193.467V14a.667.667 0 0 1-.667.667H9.007A.667.667 0 0 1 8.34 14Z" />
    </svg>
  )
}

const AddIcon = ({ color = "#00b432" }) => {
  return (
    <svg width="21" height="21" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.709 20.91c5.45 0 9.96-4.521 9.96-9.96 0-5.45-4.52-9.962-9.97-9.962C5.26.988.748 5.5.748 10.95c0 5.44 4.522 9.961 9.961 9.961Zm0-1.66a8.26 8.26 0 0 1-8.291-8.3c0-4.61 3.672-8.302 8.281-8.302 4.61 0 8.301 3.692 8.31 8.301a8.263 8.263 0 0 1-8.3 8.301Zm-4.316-8.291c0 .478.341.8.84.8h2.646v2.667c0 .488.332.82.81.82.489 0 .83-.332.83-.82V11.76h2.657c.488 0 .83-.323.83-.801 0-.488-.342-.83-.83-.83H11.52V7.482c0-.507-.342-.84-.83-.84-.48 0-.811.342-.811.84v2.647H7.232c-.498 0-.84.342-.84.83Z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  )
}

const RemoveIcon2 = ({ color = "#EF4444", width = 21 }) => {
  return (
    <svg
      width={width}
      height="21"
      viewBox="0 0 21 21"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.709 20.91c5.45 0 9.96-4.521 9.96-9.96 0-5.45-4.52-9.962-9.97-9.962C5.26.988.748 5.5.748 10.95c0 5.44 4.522 9.961 9.961 9.961Zm0-1.66a8.26 8.26 0 0 1-8.291-8.3c0-4.61 3.672-8.302 8.281-8.302 4.61 0 8.301 3.692 8.31 8.301a8.263 8.263 0 0 1-8.3 8.301Zm-3.838-7.47h7.666c.547 0 .918-.294.918-.811 0-.528-.351-.83-.918-.83H6.871c-.566 0-.928.302-.928.83 0 .517.381.81.928.81Z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  )
}

export {
  ProfileIcon,
  CameraIcon,
  PasswordIcon,
  VaccineIcon,
  BenefitsIcon,
  InsuranceIcon,
  ResumeIcon,
  SettingsIcon,
  CompanyIcon,
  EditIcon,
  BankIcon,
  UndoIcon,
  ArrowBack,
  ArrowRight,
  UserInfoIcon,
  PhoneIcon,
  HomeLocationIcon,
  CheckIcon,
  Check2Icon,
  RemoveIcon,
  QuestionMarkIcon,
  UploadIcon,
  ExclamationIcon,
  AssetIcon,
  PdfIcon,
  LinkIcon,
  CopyIcon,
  AddIcon,
  RemoveIcon2,
}
